import { ShieldCheck, Truck, Sparkles, Star } from 'lucide-react';

/** #16 — Trust strip below hero. Wins skeptics in 2 seconds. */
export default function TrustStrip() {
  const items = [
    { icon: ShieldCheck, label: 'Secure checkout', sub: 'GCash · Maya · Cards' },
    { icon: Truck, label: 'Same-day Metro Manila', sub: 'Lalamove dispatch' },
    { icon: Sparkles, label: '100% Authentic', sub: 'Crafted in PH · Verified brand' },
    { icon: Star, label: '4.9 / 5 from buyers', sub: 'Verified reviews' },
  ];
  return (
    <section
      className="border-y border-white/5 bg-[#0A0A0A]/60 backdrop-blur-sm"
      data-testid="trust-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 divide-x divide-white/5">
        {items.map((item, i) => {
          const Icon = item.icon;
          return (
            <div key={i} className="flex items-center gap-3 px-3 sm:px-5 py-4 sm:py-5" data-testid={`trust-item-${i}`}>
              <Icon className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
              <div className="min-w-0">
                <p className="text-white text-xs sm:text-[13px] font-sans font-medium leading-tight truncate">{item.label}</p>
                <p className="text-white/40 text-[10px] sm:text-[11px] font-sans truncate">{item.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
